import React from 'react';
import contentieuxImg from '../../assets/competences/contentieux.jpg';
import fonctionPubliqueImg from '../../assets/competences/fonctionPublique.png';
import marchePublicImg from '../../assets/competences/marchePublic.jpg';
import responsabiliteMedicaleImg from '../../assets/competences/responsabiliteMedicale.jpg';
import urbanismeImg from '../../assets/competences/urbanisme.jpg';
import IconContentieux from '../components/icons/IconContentieux';
import IconFonctionPublique from '../components/icons/IconFonctionPublique';
import IconMalette from '../components/icons/IconMalette';
import IconMarche from '../components/icons/IconMarche';
import IconUrbanisme from '../components/icons/IconUrbanisme';

export default [
  {
    title: 'Fonction publique',
    name: 'fonctionPublique',
    text: `Le cabinet vous accompagne dans l’ensemble des démarches amiables et contentieux relatifs aux trois fonctions publiques, d’État, territoriale et hospitalière.

Les problématiques des agents fonctionnaires titulaires et contractuels sont régulièrement traitées au sein du cabinet.

De plus, l’expertise en droit du travail, de Me LACROIX au sein de la SCM PORTE DE FRANCE, permet d’aborder sous ses différents aspect, la question des salariés protégés.`,
    img: fonctionPubliqueImg,
    icon: <IconFonctionPublique size={40} />,
  },
  {
    title: 'Contentieux des aides sociales',
    name: 'contentieuxDesAidesSociales',
    text: `Le cabinet vous accompagne dans le cadre des recours amiables et contentieux relatifs aux prestations sociales, indus et autres problématiques relatives aux aides sociales.

L’assistance et la défense dans le cadre de la reconnaissance de certain statut, type reconnaissance d’invalidité, de travailleur handicapé, carte de stationnement, etc, relève également de notre expertise.

La technicité de ces contentieux nécessite régulièrement la présence d’un conseil que le cabinet est en mesure de vous apporter.`,
    img: contentieuxImg,
    icon: <IconContentieux size={40} />,
  },
  {
    title: 'Urbanisme et construction',
    name: 'urbanismeEtConstruction',
    text: `Le cabinet vous accompagne dans l’ensemble des démarches et contentieux relatifs à l’urbanisme, notamment recours ou défense des autorisations d’urbanisme (permis de construire, déclaration préalable, certificat d’urbanisme, règlements d’urbanisme, etc).

Des consultations sont aussi réalisées au cabinet concernant l’ensemble de ces problématiques.`,
    img: urbanismeImg,
    icon: <IconUrbanisme size={40} />,
  },
  {
    title: 'Responsabilité médicale',
    name: 'responsabiliteMedicale',
    text: `Le cabinet vous accompagne dans les démarches amiables et contentieuses relatives aux questions de responsabilité médicale et notamment, saisine des commissions régionales de conciliation et d’indemnisation (CRCI) ainsi que des juridictions à la suite d’un accident médical.

L’assistance et la défense dans le cadre des expertises diligentées relèvent également de nos compétences.`,
    img: responsabiliteMedicaleImg,
    icon: <IconMalette size={40} />,
  },
  {
    title: 'Marché public',
    name: 'marchePublic',
    text: `Le cabinet accompagne régulièrement des entreprises et des collectivités dans le cadre de la passation, de l’attribution mais également des contentieux relatifs au droit des marchés publics.

Notre expertise nous permet d’intervenir en amont de ces derniers afin d’apporter des conseils mais également en suite de ces passations, dans le cadre des différentes procédures judiciaires (référés divers et procédures au fond) mises à disposition des intervenants afin de faire éventuellement cesser une illégalité.`,
    img: marchePublicImg,
    icon: <IconMarche size={40} />,
  },
];



// WEBPACK FOOTER //
// ./src/app/data/competences.js